/* AGS — Expertise page: the team blocks settle in as they arrive. Visible without JS. */
(function () {
  var teams = [].slice.call(document.querySelectorAll('.ex-ed'));
  if (!teams.length) return;
  document.documentElement.classList.add('ex-js');
  if (!('IntersectionObserver' in window)) { teams.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  teams.forEach(function (el) { io.observe(el); });
  /* a jump (anchor, restored scroll) can land below a block before it is observed */
  window.addEventListener('scroll', function () { teams.forEach(function (el) { if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('is-in'); io.unobserve(el); } }); }, { passive: true });
})();
